import { render } from "./FiltersTable.vue?vue&type=template&id=c2f105d6&scoped=true"
import script from "./FiltersTable.vue?vue&type=script&lang=js"
export * from "./FiltersTable.vue?vue&type=script&lang=js"

import "./FiltersTable.vue?vue&type=style&index=0&id=c2f105d6&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2f105d6"]])

export default __exports__